import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError, RouteConfigLoadStart, RouteConfigLoadEnd } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { LoaderService } from './core/services/loader.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'enclaveApp';
  isLoading$ = this.loaderService.loading$;
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private loaderService: LoaderService
  ) {}

  ngOnInit(): void {
    this.setupRouterEventListeners();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Set up router event listeners to show/hide loader during route transitions
   */
  private setupRouterEventListeners(): void {
    this.router.events
      .pipe(takeUntil(this.destroy$))
      .subscribe(event => {
        // Show loader when route navigation starts or lazy module starts loading
        if (event instanceof NavigationStart || event instanceof RouteConfigLoadStart) {
          this.loaderService.show();
        }
        
        // Hide loader when route navigation ends, is cancelled, or fails
        if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError ||
          event instanceof RouteConfigLoadEnd
        ) {
          this.loaderService.hide();
        }
      });
  }
}
